import axios, { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

export class InvalidParameterException extends Error {
  constructor(message: string) {
    super(message);
  }
}

@Injectable({ providedIn: 'root' })
export class HttpService {
  http: AxiosInstance;
  appClientId: string;

  constructor() {
    const appClientId = environment.cmsSettings.appClientId;
    if (appClientId === '') {
      throw new InvalidParameterException('appClientId cannot be empty.');
    }

    this.http = axios.create();
    this.http.defaults.headers.common['appClientId'] = appClientId;
    //this.http.defaults.headers.common['Content-Type'] = 'application/json';
    this.appClientId = appClientId;
    axiosRetry(this.http, {
      retries: 3,
      retryCondition: retryConditionFn,
      onRetry: (retryCount, error, requestConfig) => {
        requestConfig.headers = JSON.parse(JSON.stringify(error?.config?.headers));
      },
    });
  }

  public addAuthentication(accessToken: string): void {
    this.http.defaults.headers['access_token'] = accessToken;
  }

  public removeAuthentication(): void {
    delete this.http.defaults.headers['access_token'];
  }
}
const retryConditionFn = (error: any) => {
  if (error && error.response && error.response.data && error.response.data.message == null) {
    return true;
  }
  return false;
};
